// extracted by mini-css-extract-plugin
export default {"container":"format-page_container__1JkiI","filters":"format-page_filters__3OHU_"};